import React, { ReactNode, useEffect, useState } from 'react';
import Modal from '../../../../components/Dialog/Modal';
import LCFlexContainer from '../../../../components/Layout/LCFlexContainer';
import LcLoading from '../../../../components/Generic/LcLoading';
import { WorkType } from '../../../../models/WorkType';
import { SolicitationView } from '../../../../models/SolicitationView';
import { WorkView } from '../../../../models/WorkView';
import SolicitationDynamicForm from '../../SolicitationAttendantDetails/SolicitationDynamicForm';
import { PPIconLink, PPModal } from 'processor-plataform-ui';

import SolicitationService from '../../../../services/SolicitationService/SolicitationService';
import { PPFormHH, PPFormTemplate } from '../../../../components/Layout/PPFormHH/PPFormHH';
import ServiceService from '../../../../services/ServiceService/ServiceService';
import LcIconLink from '../../../../components/Generic/LcIconLink';
import LcIcon from '../../../../components/Generic/LcIcon';
import LcCheckBox from '../../../../components/Form/LcCheckBox';
import LCFlexItem from '../../../../components/Layout/LCFlexItem';
import WorkService, { Validate } from '../../../../services/WorkService/WorkService';

interface Props {
    solicitation: SolicitationView;
    work: WorkView;
    onCloseEvent: Function;
    open: boolean;
    content: string;
    confirmMessage: string;
    abortMessage: string;
    workTypeMultiple?: any[]
}

const NewWorkMultiple: React.FC<Props> = (props) => {
    const workService = new WorkService(props);
    const [loadingGeral, setLoadingGeral] = useState<boolean>(false);
    const [visibleForm, setVisibleForm] = useState<boolean>(false);

    const serviceService = new ServiceService(props);
    const solicitationService = new SolicitationService(props);
    const [templatePPForm, setTemplatePPForm] = useState<PPFormTemplate>();
    const [resultDataResult, setResultDataResult] = useState<any>();
    const [refreshSeed, setRefreshSeed] = useState<number>();
    const [error, setError] = useState<any>();
    const [optionColumns, setOptionColumns] = useState<any>([]);

    useEffect(() => {
        setTemplatePPForm(undefined);
        setResultDataResult([]);

        if (props.workTypeMultiple) {
            setOptionColumns(props.workTypeMultiple.map(item => ({
                id: item.id,
                value: true
            })));
        }

        if (props.solicitation) {
            buildExtraForm();
        }
    }, [props.solicitation]);

    const getWindowSize = () => {
        const { innerHeight } = window;
        return innerHeight;
    }

    const [windowHeight, setWindowHeight] = useState<number>(getWindowSize());

    useEffect(() => {
        function handleWindowResize() {
            setWindowHeight(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    const buildExtraForm = async () => {
        setLoadingGeral(true);

        const itemTemp = props.solicitation;

        try {
            var response = await serviceService.getForm(props.solicitation.idProcess, false, false, props.solicitation.idService, props.solicitation.id);
            var solicitationResponse = await solicitationService.GetDynamicFormData(props.solicitation.id);

            if (itemTemp === props.solicitation) {
                setResultDataResult(solicitationResponse.data); // valores campos
                setTemplatePPForm(response.data); // template campos
            }
        }
        catch (e) {
            debugger;
        }

        setLoadingGeral(false);
    }

    const handleResultData = (data: any) => {
        setResultDataResult(data);
    }

    const formStyle = {
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        justifyContent: "center",
    } as React.CSSProperties;

    const containerStyle = {
        flexWrap: "wrap",
        maxHeight: (templatePPForm && templatePPForm.fields.length > 25)
            ? '1600px'
            : (templatePPForm && templatePPForm.fields.length > 15)
                ? '1000px'
                : '600px',
    } as React.CSSProperties;

    const Save = async () => {
        setLoadingGeral(true);
        setVisibleForm(false);

        try {
            const workTypeListCreate = props.workTypeMultiple && props.workTypeMultiple.filter(x => optionColumns.find(y => y.id === x.id && y.value === true));

            const objList = {
                solicitation: props.solicitation,
                work: props.work,
                resultWorkTypes: workTypeListCreate
            }

            try {
                await workService.CreateWorkProcessWorkTypeList(objList);
                props.onCloseEvent && props.onCloseEvent(true);
            }
            catch (error) {
                debugger
            }
        }
        catch (e) {
            debugger;
        }

        setLoadingGeral(false);
    }

    return (
        <Modal
            width={(visibleForm) ? "80%" : "600px"}
            title={'Novo(s) trabalho(s)'}
            visible={props.open}
            close={() => { if (props.onCloseEvent != null) props.onCloseEvent(false); }}
        >
            <LcLoading loading={loadingGeral}>
                <>
                    <div
                        style={{
                            display: 'flex',
                            flexFlow: 'row nowrap',
                            justifyContent: 'space-between',
                            height: (visibleForm) ? '440px' : 'auto'
                        }}>
                        <div>
                            {
                                props.workTypeMultiple && props.workTypeMultiple
                                    .sort((a: { description: string; }, b: { description: string; }) => {
                                        return a.description < b.description ? -1 : a.description > b.description ? 1 : 0;
                                    })
                                    .map(x => {

                                        return (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    justifyContent: 'flex-start'
                                                }}>

                                                <LcCheckBox
                                                    name={'show'}
                                                    title={x.description}
                                                    checked={(optionColumns && optionColumns.find(y => y.id === x.id)) ? optionColumns.find(y => y.id === x.id).value : false}
                                                    onChange={() => {
                                                        setOptionColumns(optionColumns.map(item => {
                                                            if (item.id === x.id) {
                                                                return { ...item, value: !item.value };
                                                            }

                                                            return item;
                                                        }))
                                                    }} />

                                            </div>
                                        )
                                    })
                            }
                        </div>

                        <div style={{ position: 'relative', right: '5px' }}>
                            {
                                templatePPForm &&
                                <LcIconLink
                                    icon={"ppi ppi-clipboard-list"}
                                    size={"medium"}
                                    onClick={() => setVisibleForm(!visibleForm)}
                                    color={'black'}
                                    activedAfterClick={visibleForm}
                                    tooltip={(visibleForm) ? 'Ocultar formulário' : 'Exibir formulário'}
                                />
                            }
                        </div>

                        {
                            templatePPForm && visibleForm &&
                            <div style={{ width: '50%', overflow: 'auto' }}>
                                <span style={{ fontWeight: "600" }}>{(templatePPForm && templatePPForm.title) ? templatePPForm.title : ''}</span>
                                <div style={{ marginTop: "10px" }} />
                                <PPFormHH
                                    header={''}
                                    EditForm={false}
                                    data={resultDataResult}
                                    template={templatePPForm}
                                    detailButton={false}
                                    visible={true}
                                    refreshSeed={refreshSeed}
                                    setResultData={(data) => handleResultData(data)}
                                    setError={(error) => { setError(error); }}
                                    maxWidth={"10rem"}
                                    maxWidthInternal={"10rem"}
                                    direction={"row"}
                                    formStyle={formStyle}
                                    containerStyle={containerStyle}
                                    disableFields={true}
                                />
                            </div>
                        }
                    </div>

                    <div className={"row end"}
                        style={{ marginTop: '20px' }}>
                        <button
                            style={{ margin: '10px' }}
                            className={'lc-button bg-info'}
                            id={'Ok'}
                            onClick={() => Save()}
                            disabled={optionColumns.filter(x => x.value === true).length === 0}
                            color={"primary"}>
                            Ok
                        </button>
                        <button
                            style={{ margin: '10px' }}
                            className={'lc-button bg-info-alt'}
                            id={'Cancelar'}
                            onClick={() => { if (props.onCloseEvent !== null) props.onCloseEvent(false); }}
                            color={"primary"}>
                            Cancelar
                        </button>

                    </div>
                </>
            </LcLoading>
        </Modal>
    );
};

export default NewWorkMultiple;